import React, { createContext, useReducer } from 'react';
import { useUserContext } from './UserContext';

// Объект контекста
export const TaskContext = createContext({});
// Начальное состояние задач
const initialState = {
  tasks: [], // Массив задач
  filterBy: '', // Текущий фильтр (статус или другое условие)
  tasksLoading: true,
  hostname: process.env.REACT_APP_API_URL || "" //process.env.REACT_APP_API_URL
};

// Редюсер для изменения состояния задач
const taskReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_TASK':
      debugger;
        let idx = state.tasks.findIndex((task)=>{return task._id === action.payload.task._id})
        if (idx === -1){
          return {
            ...state,
            tasks: [...state.tasks, action.payload.task],
          };
        } else {
          return{
            ...state
          }
        }
    case 'UPDATE_TASK':
       return {
        ...state,
        tasks: state.tasks.map(task => {
          if (task._id !== action.payload.id) return task;

          const updated = { ...action.payload.updatedTask };

          // Файлы: если сервер вернул files — берём их как есть.
          // Если не вернул — оставляем старые.
          if (Array.isArray(action.payload.files)) {
            updated.files = action.payload.files;
          } else if (Array.isArray(task.files)) {
            updated.files = task.files;
          }

          // Служебные поля не теряем
          updated.creator = task.creator;
          updated.createDate = task.createDate;

          return updated;
        }),
      };
    case 'DELETE_TASK':
      return {
        ...state,
        tasks: state.tasks.filter(task => task._id !== action.payload.id),
      };
    case 'FILTER_TASKS':
      return {
        ...state,
        filterBy: action.payload.filterValue,
      };
    case 'GET_TASKS':
      return {
          ...state,
          tasks: (action.payload.tasks || []).map((t) => ({
            ...t,
            executors: Array.isArray(t.executors)
              ? t.executors
              : (t.executor ? [t.executor] : []),
          })),
          tasksLoading: false,
        };
    case 'SET_TASKS_LOADING':
      return {
        ...state,
        tasksLoading: action.payload.loading,
      };
    default:
      return state;
  }
};

// Экспорт самого контекста
export default TaskContext;
export const TaskProvider = ({ children }) => {
  const [state, dispatch] = useReducer(taskReducer, initialState);
const {logout} = useUserContext();
  // Методы для манипуляции задачами
  const addTask = async (credentials, files) => {
    try{
    
    const response = await fetch(initialState.hostname+'/tasks/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
      if (data.success) {
        if (files && files.length>0){
        const formData = new FormData();
        files.forEach((file) => {
          formData.append('files', file); // 'files' is the key your backend expects
        });
        // let uploaded;
        try {
          const response = await fetch(initialState.hostname+'/tasks/uploadFiles/'+ data.data._id, {
            method: 'POST',
            headers: {
              // 'Content-Type': 'multipart/form-data',
              'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
            },
            body: formData,
          });
          let res = await response.json();
          if (res.success){
              dispatch({
              type: 'ADD_TASK',
              payload: { task: {...credentials, files:res.data, _id: data.data._id} },
            });
          }
          // Handle response
        } catch (error) {
          console.error(error);
        }
      } else {
        dispatch({
              type: 'ADD_TASK',
              payload: { task: {...credentials, _id: data.data._id} },
            });
      }
        
      }
    
    } catch (err) {
      console.error(err);
    }
  };

  const updateTask = async (credentials, id, files) => {
    try{
    const response = await fetch(initialState.hostname+'/tasks/update/' + id, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
      if (data.success) {
        if (files && files.length>0){
        const formData = new FormData();
        files.forEach((file) => {
          formData.append('files', file); // 'files' is the key your backend expects
        });
        // let uploaded;
        try {
          const response = await fetch(initialState.hostname+'/tasks/uploadFiles/'+ id, {
            method: 'POST',
            headers: {
              // 'Content-Type': 'multipart/form-data',
              'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
            },
            body: formData,
          });
          let res = await response.json();
          if (res.success){
              // if (!credentials.files) credentials.files = [];
              dispatch({
              type: 'UPDATE_TASK',
              payload: { id: id, updatedTask: {...credentials, _id: id}, files: res.data },
            });
          }
          // Handle response
        } catch (error) {
          console.error(error);
        }
      } else {
        dispatch({ type: 'UPDATE_TASK', payload: { id: id, updatedTask: {...credentials, _id: id} } });
      }
        
      }
    
    } catch (err) {
      console.error(err);
    }
    // dispatch({ type: 'UPDATE_TASK', payload: { id: updatedTask.id, updatedTask } });
  };

  const deleteFile = async (id, link) => {
    try {
      const response = await fetch(initialState.hostname+'/tasks/delFile/'+ id +'/'+link, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        console.log(data);
        dispatch({ type: 'UPDATE_TASK', payload: { id: id, updatedTask: data.data } });
        // dispatch({ type: 'DELETE_TASK', payload: { id } });
        return data;
    } catch (error) {
      console.log(error);
    }
  }

  const deleteTask = async id => {
     try {
      const response = await fetch(initialState.hostname+'/tasks/task/'+ id, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'DELETE_TASK', payload: { id } });
        return data;
    } catch (error) {
      console.log(error);
    }
  };

  const applyFilter = filterValue => {
    dispatch({ type: 'FILTER_TASKS', payload: { filterValue } });
  };

  const fetchTasks = async () => {
    dispatch({ type: 'SET_TASKS_LOADING', payload: { loading: true } });
    try {
      const response = await fetch(initialState.hostname+'/tasks/getTasks', {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'GET_TASKS', payload: { tasks: data.data } });
        return data;
    } catch (error) {
      console.log(error);
      dispatch({ type: 'SET_TASKS_LOADING', payload: { loading: false } });
    }
  }

  const socketCreate = async(data)=>{
    dispatch({
      type: 'ADD_TASK',
      payload: { task: data },
    });
  }
  const socketUpdate = async(id, data)=>{
    dispatch({ type: 'UPDATE_TASK', payload: { id: id, updatedTask: data } });
  }
  const socketDelete = async(id, data)=>{
    dispatch({ type: 'DELETE_TASK', payload: { id } });
  }

  return (
    <TaskContext.Provider value={{
      tasks: state.tasks,
      tasksLoading: state.tasksLoading,
      filterBy: state.filterBy,
      addTask,
      updateTask,
      deleteTask,
      applyFilter,
      fetchTasks,
      deleteFile,
      socketCreate,
      socketUpdate,
      socketDelete,
    }}>
      {children}
    </TaskContext.Provider>
  );
};
export const useTaskContext = () => {
  const context = React.useContext(TaskContext);
  if (!context) throw new Error("useTaskContext must be used within a UserProvider");
  return context;
};